// Lightweight FingerprintJS wrapper. Loaded once per page, cached in-memory,
// with a localStorage fallback so scan requests never block on the FP agent.
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const LS_KEY = "resell_ai_device_fp";
let fpPromise = null;
let cachedId = null;

export function getCachedDeviceFp() {
  if (cachedId) return cachedId;
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v) { cachedId = v; return v; }
  } catch {}
  return null;
}

export async function getDeviceFp() {
  const cached = getCachedDeviceFp();
  if (cached) return cached;
  if (!fpPromise) fpPromise = FingerprintJS.load();
  try {
    const fp = await fpPromise;
    const result = await fp.get();
    cachedId = result.visitorId;
    try { localStorage.setItem(LS_KEY, cachedId); } catch {}
    return cachedId;
  } catch {
    return null; // graceful — server tolerates missing fp
  }
}
